<h1 mat-dialog-title>{{'Dialogs.Alert.PlaceNumberError.Title' | translate}}</h1>
<div mat-dialog-content>
  <p>{{'Dialogs.Alert.PlaceNumberError.Detail' | translate}}</p>
</div>
<div mat-dialog-actions align="end">
  <button *ngIf="data.showpicklocation" mat-button [mat-dialog-close]="true">{{'Dialogs.Alert.PlaceNumberError.PickLocation' | translate}}</button>
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial>{{'Dialogs.Alert.PlaceNumberError.Accept' | translate}}</button>
</div>